import { VolunteerLayout } from '@layouts/VolunteerLayout/VolunteerLayout';
import { Section } from '@layouts/Section/Section';
import { ProfileForm } from '@components/volunteers/organisms/ProfileForm/ProfileForm';
import { useUserContext } from '@contexts/UserContext';
import { updateProfile } from '@services/profiles';
import { UserProfile } from '@services/profiles';
import { useNavigate } from 'react-router-dom';
import { ToastRoot } from '@acb_devel/design-system';
import { useToastContext } from '@acb_devel/design-system';
import { Alert } from '@acb_devel/design-system';

import styles from './EditProfilePage.module.scss';
import { useEffect } from 'react';

export default function EditProfilePage() {
  const { user, setUser } = useUserContext();
  const { addToast } = useToastContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.profile) {
      navigate('/user/create-profile');
    }
  }, [user, navigate]);

  function updateProfileSubmit(userProfile: UserProfile) {
    if (!user?.profile) {
      return;
    }

    updateProfile(user.profile.id, userProfile)
      .then((updatedUserProfile) => {
        setUser({
          ...user,
          profile: updatedUserProfile,
        });

        addToast(
          <ToastRoot>
            <Alert
              variant="success"
              direction="row"
              title={`Perfil actualizado correctamente`}
            />
          </ToastRoot>
        );

        navigate('/user/profile');
      })
      .catch((error) => {
        addToast(
          <ToastRoot>
            <Alert
              variant="error"
              direction="column"
              title={`Error al actualizar el perfil`}
              text="Ha ocurrido un error al actualizar tu perfil. Por favor, inténtalo de nuevo."
            />
          </ToastRoot>
        );
        console.error(error);
      });
  }

  return (
    <VolunteerLayout>
      <Section className={styles.editSection}>
        <ProfileForm defaultValues={user} onSubmit={updateProfileSubmit} />
      </Section>
    </VolunteerLayout>
  );
}
